import React, { useState, useEffect, useRef } from "react";
import { withNamespaces } from "react-i18next";
import axios from "axios";
import CreateEditUser from "./CreateEditUser.js";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const UsersList = (props) => {
  let users = props.data;
  let roles = props.dataRoles;
  let rolesUI = props.dataRolesUI;
  let link = localStorage.getItem("link");
  const activeRights = JSON.parse(localStorage.getItem("rights"));

  const [popUpShow, setPopUpShow] = useState(false);
  const [currentUserData, setCurrentUserData] = useState();
  const [userName, setUserName] = useState(localStorage.getItem("userName"));

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  function editCreateUser(userData) {
    setCurrentUserData(userData);
    setPopUpShow(true);
  }

  const deleteUser = (userData) => {
    let name = userData.userName;
    let data = {
      username: name,
    };

    confirmAlert({
      message: props.t("allgemein.bestaetigen"),
      buttons: [
        {
          label: props.t("allgemein.ja"),
          onClick: () =>
            axios
              .post(link + "/api/User/delete", data, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: props.t("allgemein.nein"),
        },
      ],
    });
  };

  const activateUser = (userData) => {
    let name = userData.userName;
    let data = {
      username: name,
    };

    confirmAlert({
      message: props.t("administration.benutzer.activateUser"),
      buttons: [
        {
          label: props.t("allgemein.ja"),
          onClick: () =>
            axios
              .post(link + "/api/User/setactive", data, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: props.t("allgemein.nein"),
        },
      ],
    });
  };

  const inActivateUser = (userData) => {
    let name = userData.userName;
    let data = {
      username: name,
    };

    confirmAlert({
      message: props.t("administration.benutzer.deactivateUser"),
      buttons: [
        {
          label: props.t("allgemein.ja"),
          onClick: () =>
            axios
              .post(link + "/api/User/setinactive", data, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: props.t("allgemein.nein"),
        },
      ],
    });
  };

  function usersList() {
    let usersList = [];

    for (let i = 0; i < users.length; i++) {
      if (users[i].userName != "multiGuide" && users[i].userName != userName) {
        let activated;
        let isMultiGuideAdmin;
        let canChange;
        let roleNames;
        let lang;

        users[i].activated == true
          ? (activated = props.t("allgemein.ja"))
          : (activated = props.t("allgemein.nein"));
        users[i].isMultiGuideAdmin == true
          ? (isMultiGuideAdmin = props.t("allgemein.ja"))
          : (isMultiGuideAdmin = props.t("allgemein.nein"));
        users[i].canChange == true
          ? (canChange = props.t("allgemein.ja"))
          : (canChange = props.t("allgemein.nein"));
        lang = users[i].languageCode != null ? users[i].languageCode : "de";
        roleNames =
          users[i].roleNames != null ? users[i].roleNames.join(", ") : "";

        usersList.push(
          <tr key={"key_" + i}>
            <td>{users[i].userName}</td>
            <td>{users[i].eMail}</td>
            <td>{activated}</td>
            <td>{roleNames}</td>
            <td>{lang}</td>
            <td>
              {activeRights.includes("User.SetActive") &&
                !users[i].activated && (
                  <i
                    className="bx bxs-user-check bx-sm"
                    style={{ marginLeft: "10px" }}
                    onClick={() => activateUser(users[i])}
                    title={props.t("administration.benutzer.activateUser")}
                  ></i>
                )}
              {activeRights.includes("User.SetInactive") &&
                users[i].activated && (
                  <i
                    className="bx bxs-user-check bx-sm"
                    style={{ marginLeft: "10px" }}
                    onClick={() => inActivateUser(users[i])}
                    title={props.t("administration.benutzer.deactivateUser")}
                  ></i>
                )}
              {activeRights.includes("User.Update") && (
                <i
                  className="bx bx-edit bx-sm"
                  style={{ marginLeft: "10px" }}
                  onClick={() => editCreateUser(users[i])}
                  title={props.t("allgemein.Bearbeiten")}
                ></i>
              )}
              {activeRights.includes("User.Delete") && (
                <i
                  className="bx bx-trash bx-sm"
                  style={{ marginLeft: "10px" }}
                  onClick={() => deleteUser(users[i])}
                  title={props.t("allgemein.Loeschen")}
                ></i>
              )}
            </td>
          </tr>
        );
      }
    }

    return <tbody>{usersList}</tbody>;
  }

  function popUpChange() {
    props.onChange();
    setPopUpShow(false);
  }

  return (
    <div style={{ width: "80%", margin: "auto" }}>
      {popUpShow == true && (
        <div>
          {
            <CreateEditUser
              type={"createEditDeleteUser"}
              data={currentUserData}
              dataRoles={roles}
              dataRolesUI={rolesUI}
              onChange={popUpChange}
            >
              {" "}
            </CreateEditUser>
          }
        </div>
      )}
      {popUpShow == false && (
        <>
          <h3>{props.t("administration.createEditDeleteUser")}</h3>
          <div className="einstellungen-box">
            <div className="box-name">
              {props.t("administration.createEditDeleteUser")}
            </div>
            <div style={{ overflow: "auto" }}>
              <table id="createEditDeleteUserTable">
                <thead>
                  <tr>
                    <th>{props.t("login.labelBenutzername")}</th>
                    <th>{props.t("administration.benutzer.labelEMail")}</th>
                    <th>{props.t("administration.benutzer.activated")}</th>
                    <th>{props.t("administration.benutzer.role")}</th>
                    <th>{props.t("administration.benutzer.labelSprache")}</th>

                    <th>
                      {activeRights.includes("User.Create") && (
                        <button
                          className="button"
                          id="pop-up-button"
                          style={{ width: "80px" }}
                          onClick={() => editCreateUser()}
                        >
                          {props.t("allgemein.Neu")}
                        </button>
                      )}
                    </th>
                  </tr>
                </thead>
                {usersList()}
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default withNamespaces()(UsersList);
